module.exports = __webpack_public_path__ + "img/icon-cup-2.9310cac2.svg";